import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, HeadingStyled, LazyImage, MainHeading, SpanStyled, TextStyled } from '../../ui/Elements'
import { AboutBg, AboutImg, AbtTxtImg, AbtTxtImgAr, ArrowBtnBrown, OurGoals, OurMission, OurVision, StatsBg1, StatsBg2, StatsBg3, StatsBg4, StripeBg, StripeBgAr } from '../../ui/AllImages'
import { useTranslation } from 'react-i18next'
import { AboutBox } from '../../ui/CustomElements'
import i18n from '../../Languages/INEXT'
import { AboutData } from '../projectData/Data'
import { Animate } from 'react-simple-animate'
import Marquee from './Marquee'

const About = () => {
    const { t } = useTranslation();
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                // When visible, set to true
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            {
                threshold: 0.2,
            }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);
    /* useEffect(() => {
        const element = sectionRef.current;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            {
                threshold: 0.4
            }
        );

        if (element) {
            observer.observe(element);

            const rect = element.getBoundingClientRect();
            const inView =
                rect.top < window.innerHeight &&
                rect.bottom >= 0;

            if (inView) {
                setIsVisible(true);
                observer.disconnect();
            }
        }

        return () => observer.disconnect();
    }, []); */
    
    
    const start = { opacity: 0, transform: 'translateY(-20px)' };
    const end = { opacity: 1, transform: 'translateY(0)' };

    return (
        <Box  id='about'>
            <AboutWapper className='container-fluid secAbout common-space'>
                <Container>
                    <Row className='about-row' >
                        <Col md={12} className='about-h-row'>
                            <Animate
                                play={isVisible}
                                duration={1}
                                // delay={.5}
                                

                                start={start}
                                end={end}
                            >
                                <MainHeading className='main-heading mb-3 main-heading-about' size="40px">
                                    <SpanStyled className='aboutH1'>{t('aboutHeading1')}</SpanStyled> <SpanStyled className='aboutH2'>{t('aboutHeading2')}</SpanStyled> <SpanStyled className='aboutH3'>{t('aboutHeading3')}</SpanStyled> <SpanStyled className='aboutH4'>{t('aboutHeading4')}</SpanStyled> 
                                </MainHeading>
                            </Animate>
                        </Col>
                        
                        <Col md={12} className='' ref={sectionRef}>
                            <Row className=''>
                                <Col lg={4} md={12} className='aboutCols'>
                                    <Box className='whyChooseContent'>
                                        <Box className='why-c-wapper'>
                                            <Box className='w-choose-content'>
                                                <Box className='w-choose-icon'>
                                                    <Animate
                                                        play={isVisible}
                                                        duration={1}
                                                        delay={.5}
                                                        start={start}
                                                        end={end}
                                                    >
                                                        <OurVision />
                                                    </Animate>
                                                </Box>
                                                <Box>
                                                    <Animate
                                                        play={isVisible}
                                                        duration={1}
                                                        delay={.8}
                                                        start={start}
                                                        end={end}
                                                    >
                                                        <Box  color='var(--themeColor)' className='hStyled'>
                                                            {t('aboutH1')}
                                                        </Box>
                                                    </Animate>
                                                    <Animate
                                                        play={isVisible}
                                                        duration={1}
                                                        delay={1.2}
                                                        start={start}
                                                        end={end}
                                                    >
                                                        <TextStyled size="18px">{t('aboutT1')}</TextStyled>
                                                    </Animate>
                                                </Box>
                                            </Box>
                                                
                                        </Box>
                                    </Box>
                                </Col>
                                <Col lg={4} md={12} className='aboutCols'>
                                    <Box className='whyChooseContent'>
                                        <Box className='why-c-wapper'>
                                            <Box className='w-choose-content'>
                                                <Box className='w-choose-icon'>
                                                    <Animate
                                                        play={isVisible}
                                                        duration={1}
                                                        delay={.5}
                                                        start={start}
                                                        end={end}
                                                    >
                                                    <OurMission />
                                                    </Animate>
                                                </Box>
                                                <Box>
                                                    <Animate
                                                        play={isVisible}
                                                        duration={1}
                                                        delay={.8}
                                                        start={start}
                                                        end={end}
                                                    >
                                                    <HeadingStyled color='var(--themeColor)' className='hStyled'>
                                                        {t('aboutH2')}
                                                    </HeadingStyled>
                                                    </Animate>
                                                    <Animate
                                                        play={isVisible}
                                                        duration={1}
                                                        delay={1.2}
                                                        start={start}
                                                        end={end}
                                                    >
                                                    <TextStyled>{t('aboutT2')}</TextStyled>
                                                    </Animate>
                                                </Box>
                                            </Box>
                                                
                                        </Box>
                                    </Box>
                                </Col>
                                <Col lg={4} md={12} className='aboutCols'>
                                    <Box className='whyChooseContent'>
                                        <Box className='why-c-wapper'>
                                            <Box className='w-choose-content'>
                                                <Box className='w-choose-icon'>
                                                    <Animate
                                                        play={isVisible}
                                                        duration={1}
                                                        delay={.5}
                                                        start={start}
                                                        end={end}
                                                    >
                                                    <OurGoals />
                                                    </Animate>
                                                </Box>
                                                <Box>
                                                    <Animate
                                                        play={isVisible}
                                                        duration={1}
                                                        delay={.8}
                                                        start={start}
                                                        end={end}
                                                    >
                                                    <HeadingStyled color='var(--themeColor)' className='hStyled'>
                                                        {t('aboutH3')}
                                                    </HeadingStyled>
                                                    </Animate>
                                                    <Animate
                                                        play={isVisible}
                                                        duration={1}
                                                        delay={1.2}
                                                        start={start}
                                                        end={end}
                                                    >
                                                    <TextStyled>{t('aboutT3')}</TextStyled>
                                                    </Animate>
                                                </Box>
                                            </Box>
                                                
                                        </Box>
                                    </Box>
                                </Col>
                            </Row>
                        </Col>
                        {/* <Col lg={6} md={12} className='about-col about-col-img'>
                            <Box className='abouImg'>
                                <LazyImage src={AboutImg} />
                                
                            </Box>
                            
                            
                        </Col> */}
                    </Row>
                </Container>
                
            </AboutWapper>
            <Box className='abtTx'>
                {/* {i18n.language === "ar" ? <LazyImage src={AbtTxtImg} /> : <LazyImage src={AbtTxtImgAr} />} */}
                <Marquee />
                
            </Box>
            
        </Box>
    )
}
const AboutWapper = styled.section`
    background-image: url(${AboutBg});
    background-size: cover;
    background-position: bottom center;
    .about-row {
        align-items: center;
    }
    .aboutContent{
        padding-right: 100px;
    }
    .main-heading-about{
        display: inline-block;
        span{
            color: var(--text);
            display: unset;
            font-size: 40px;
            font-family: var(--familyRbt);
            font-weight: var(--semiBold);
            &.aboutH1, &.aboutH3{
                color: var(--themeColor);
            }
        }
    }
    .about-h-row{
        margin-bottom: 80px;
    }
    .hStyled{
        font-size: 24px;
        font-family: var(--familyRbt);
        font-weight: var(--semiBold);
        color: var(--themeColor);
        margin-top: 20px;
        margin-bottom: 15px;
    }
    .abouImg{
        border-radius: 24px;
        overflow: hidden;
        span{
            width: 100%;
            height: 100%;
            img{
                width: 100%;
                height: auto;
            }
        }
    }
    .why-c-wapper{
        padding-right: 30px;
    }
    
    body.rtl &{
        .abtHeadSec{
            font-size: 24px;
        }
        .aboutContent{
            padding-right: 0px;
            padding-left: 100px;
        }
        .main-heading-about{
            display: inline-block;
            span{
                display: unset;
                font-size: 40px;
                font-family: var(--arSemiBold);
            }
        }
        .hStyled{
            margin-top: 15px;
            font-size: 28px;
            font-family: var(--arSemiBold);
        }
        .why-c-wapper{
            padding-left: 70px;
            padding-right: 0;
        }
    
    }
    @media (max-width: 1199px) {
        .aboutContent {
            padding-right: 30px;
        }
        .why-c-wapper {
            padding-left: 0px;
            padding-right: 0px;
        }
        body.rtl &{
            .aboutContent{
                padding-right: 0px;
                padding-left: 30px;
            }
            .why-c-wapper {
                padding-left: 0px;
            }
        }
    }
    @media (max-width: 991px) {
        .about-col{
            margin-bottom: 40px;
        }
        .about-col-img{
            display: none;
        }
        &.secAbout{
            padding-top: 60px;
            padding-bottom: 30px;
        }
        .main-heading-about{
            line-height: 1.1;
            span{
                font-size: 30px;
                
            }
            
        }
        .aboutContent{
            padding-right: 0;
        }
        .about-h-row {
            margin-bottom: 40px;
        }
        .aboutCols{
            margin-bottom: 30px;
        }
        body.rtl &{
            .aboutContent{
                padding-right: 0px;
                padding-left: 0px;
            }
            .main-heading-about{
                line-height: 1.1;
                span{
                    font-size: 30px;
                    
                }
                
            }
        }
        
    }
    @media (max-width: 767px) {
        
    }
    @media (max-width: 575px) {
        &.secAbout{
            padding-top: 50px;
            padding-bottom: 20px;
        }
        .main-heading-about{
            font-size: 30px;
        }
    }
`
export default About
